import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// Definindo as props que o componente irá receber
interface MediaCardProps {
  title: string;
  description: string;
  imageUrl: string;
  actions?: React.ReactNode; // Opcional, pode incluir qualquer elemento React
}

export default function CardPorqueNos({ title, description, imageUrl, actions }: MediaCardProps) {
  return (
    <Card sx={{ maxWidth: 345 }}>
      {/* <CardMedia
        sx={{ height: 140 }}
        image={imageUrl}
        title={title}
      /> */}
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      {/* <CardActions>
        {actions || (
          <>
            <Button size="small">Share</Button>
            <Button size="small">Learn More</Button>
          </>
        )}
      </CardActions> */}
    </Card>
  );
}
